(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-rows.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-rows.js');
"use strict";

const {
  AnalysisForecast,
  TipsinfoRow,
  TipsinfoRowStats
} = svs.components.tipsen.tipsinfo;
const {
  formatDecimalOdds,
  formatPercentage,
  getOddsCaption
} = svs.components.tipsen.tipsinfo.utils;
const {
  Trend
} = svs.components.lbUi.trend;
const TipsinfoRows = _ref => {
  let {
    layOutProps
  } = _ref;
  const {
    drawNumber,
    eventNumber,
    favourites,
    hasTioTidningarValues,
    hasTipsinfoStats,
    isGoalCount,
    isReduceFree,
    isResultOrMybets,
    isStartOddsEnabled,
    matchId,
    outcomeLabels,
    productId,
    selectFormattedDistribution,
    selectFormattedOdds,
    shouldDisplayFavourites,
    shouldDisplayLargeTipsinfo,
    shouldDisplayOdds,
    shouldDisplayStartOdds,
    shouldDisplaySvenskaFolket,
    shouldDisplayTioTidningar,
    showMatchAnalyseForecast,
    startOdds,
    tioTidningarTips
  } = layOutProps;
  return React.createElement("div", {
    className: "tipsinfo tipsinfo-".concat((outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.length) || '0', "col")
  }, isReduceFree && hasTipsinfoStats && React.createElement(TipsinfoRow, {
    className: "tipsinfo-bet-options-headers",
    dataTestid: "coupon-row-tipsinfo-bet-options-headers"
  }, React.createElement("div", {
    className: "tipsinfo-statistics-grid"
  }, outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map(el => React.createElement("div", {
    className: "f-center",
    key: el.text
  }, el.text)))), shouldDisplaySvenskaFolket && React.createElement(TipsinfoRow, {
    dataTestid: "coupon-row-tips-info-svenska-folket",
    title: "Svenska folket"
  }, React.createElement("div", {
    className: "tipsinfo-statistics-grid"
  }, outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map((el, i) => React.createElement(Trend, {
    key: "".concat(drawNumber, "_").concat(matchId, "_").concat(el.text),
    postfixSymbol: "%",
    selectorFunction: selectFormattedDistribution(i),
    uniqueId: "".concat(drawNumber, "_").concat(matchId, "_").concat(el.text)
  })))), shouldDisplayOdds && React.createElement(TipsinfoRow, {
    dataTestid: "coupon-row-tips-info-odds",
    title: getOddsCaption({
      isStartOddsEnabled,
      isResultOrMybets
    })
  }, React.createElement("div", {
    className: "tipsinfo-statistics-grid"
  }, outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map((el, i) => React.createElement(Trend, {
    key: "".concat(drawNumber, "_").concat(matchId, "_").concat(el.text),
    selectorFunction: selectFormattedOdds(i),
    uniqueId: "".concat(drawNumber, "_").concat(matchId, "_").concat(el.text)
  })))), shouldDisplayFavourites && React.createElement(TipsinfoRow, {
    dataTestid: "coupon-row-tips-info-favourites",
    title: "Favoritskap"
  }, React.createElement(TipsinfoRowStats, {
    className: shouldDisplayLargeTipsinfo ? 'tipsinfo-row-stats-option--lg' : '',
    sign: "%"
  }, outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map((_, i) => {
    var _favourites$current;
    return formatPercentage(favourites === null || favourites === void 0 || (_favourites$current = favourites.current) === null || _favourites$current === void 0 ? void 0 : _favourites$current.value[i]);
  }))), shouldDisplayStartOdds && React.createElement(TipsinfoRow, {
    dataTestid: "coupon-row-tips-info-start-odds",
    title: "Startodds"
  }, React.createElement(TipsinfoRowStats, null, outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map((_, i) => {
    var _startOdds$current;
    return formatDecimalOdds(startOdds === null || startOdds === void 0 || (_startOdds$current = startOdds.current) === null || _startOdds$current === void 0 ? void 0 : _startOdds$current.value[i]);
  }))), shouldDisplayTioTidningar && React.createElement(TipsinfoRow, {
    dataTestid: "coupon-row-tips-info-ten-papers",
    title: "Tio Tidningar"
  }, React.createElement(TipsinfoRowStats, {
    noValueSign: hasTioTidningarValues ? '0' : '-'
  }, outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map((_, i) => {
    var _tioTidningarTips$cur;
    return tioTidningarTips === null || tioTidningarTips === void 0 || (_tioTidningarTips$cur = tioTidningarTips.current) === null || _tioTidningarTips$cur === void 0 ? void 0 : _tioTidningarTips$cur.value[i];
  }))), showMatchAnalyseForecast && isGoalCount && React.createElement("div", {
    className: "tipsinfo-border-fulltraff"
  }), showMatchAnalyseForecast && React.createElement(AnalysisForecast, {
    dataTestid: "coupon-row-tips-info-analyse",
    drawId: drawNumber,
    eventNumber: eventNumber,
    matchId: matchId,
    productId: productId
  }));
};


setGlobal('svs.components.tipsen.tipsinfo.TipsinfoRows', TipsinfoRows);

 })(window);